export default __webpack_public_path__ + "15996261c9aab58c5f4fbb5121f33498.svg";